import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/index.vue'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {

  return originalPush.call(this, location).catch(err => err)

}

const routes = [
  {
    path: '/',
    name: 'latestCourse',
    component: () => import('../views/latestCourse/index.vue')
  },
  {
    path: '/courseTimeLine',
    name: 'courseTimeLine',
    component: () => import('../views/courseTimeLine/index.vue')
  },
  {
    path: '/courseType',
    name: 'courseType',
    component: () => import('../views/courseType/index.vue')
  },
  {
    path: '/timeTable',
    name: 'timeTable',
    component: () => import('../views/timeTable/index.vue')
  },
  // {
  //   path: '/',
  //   name: 'home',
  //   component: Home
  // },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index.vue')
  },
  {
    path: '/find',
    name: 'find',
    component: () => import('../views/find/find.vue')//暂时停用
  },

  {
    path: '/courseSort',
    name: 'courseSort',
    component: () => import('../views/courseSort/index.vue')//暂时停用
  },

  {
    path: '/shareCourse',
    name: 'shareCourse',
    component: () => import('../views/shareCourse/index.vue')//暂时停用
  },
  {
    path: '/student',
    name: 'student',
    component: () => import('../views/student/index.vue')
  },
  {
    path: '/work',
    name: 'work',
    component: () => import('../views/work/index.vue')
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('../views/feedback/index.vue')
  },
  {
    path: '/feedbackshow',
    name: 'feedbackshow',
    component: () => import('../views/feedbackShow/index.vue')
  },

]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next();
  } else {
    let token = localStorage.getItem('token');
    if (token === null || token === '') {
      next('/login');
    } else {
      next();
    }
  }
});
export default router
